import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { HeaderButtonBlockConfig } from '@front-platform/content-builder';
import { headerButtonBlockResolveConfig } from '@front-platform/content-builder';
import { Component, OnInit, input } from '@angular/core';

import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
export interface HeaderButtonBlockRuntimeConfig {}

export type HeaderButtonBlockConfigInput = Partial<
  Omit<HeaderButtonBlockConfig, keyof HeaderButtonBlockRuntimeConfig> &
    HeaderButtonBlockRuntimeConfig
>;
export type HeaderButtonBlockResolvedConfig = Omit<
  HeaderButtonBlockConfig,
  keyof HeaderButtonBlockRuntimeConfig
> &
  Partial<HeaderButtonBlockRuntimeConfig>;
export interface HeaderButtonBlockContract extends ConfigComponentContract<
  HeaderButtonBlockConfigInput,
  HeaderButtonBlockResolvedConfig
> {}

@Component({
  selector: 'app-header-button-block',
  templateUrl: './header-button-block.component.html',
  standalone: false,
})
export class HeaderButtonBlockComponent implements OnInit, HeaderButtonBlockContract {
  readonly config = input<HeaderButtonBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    HeaderButtonBlockConfig,
    HeaderButtonBlockRuntimeConfig
  >(headerButtonBlockResolveConfig, () => ({ config: this.config() }));
  get label(): string | undefined {
    return this.resolvedConfig()['label'] as unknown as string | undefined;
  }
  get linkUrl(): string | undefined {
    return this.resolvedConfig()['link_url'] as unknown as string | undefined;
  }
  private _labelMobileConfigOverride: string | undefined | undefined;
  get labelMobile(): string | undefined {
    return (
      this._labelMobileConfigOverride ??
      (this.resolvedConfig()['label_mobile'] as unknown as string | undefined)
    );
  }
  set labelMobile(value: string | undefined) {
    this._labelMobileConfigOverride = value;
  }
  get displayOnMobile(): boolean {
    return this.resolvedConfig()['display_on_mobile'] as unknown as boolean;
  }
  get displayOnDesktop(): boolean {
    return this.resolvedConfig()['display_on_desktop'] as unknown as boolean;
  }
  get backgroundColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()['background_color'] as unknown as IContentBuilderFieldColor;
  }
  get textColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor;
  }
  get fontSize(): string {
    return this.resolvedConfig()['font_size'] as unknown as string;
  }
  get fontWeight(): string {
    return this.resolvedConfig()['font_weight'] as unknown as string;
  }

  constructor() {}

  ngOnInit(): void {
    if (this.displayOnMobile && !this.labelMobile) {
      this.labelMobile = this.label;
    }
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(HeaderButtonBlockComponent, { 'keyAliases': {} });
